import React from "react";
import { Box, styled, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { colorGrayDark, colorGrayLight, colorLime } from "../../styles/theme";
import ThumbsDownIcon from "../Icons/ThumbsDownIcon";
import ThumbsUpIcon from "../Icons/ThumbsUpIcon";

export enum RelevancyValue {
	IRRELEVANT,
	RELEVANT,
}

const sharedButtonStyles = {
	borderRadius: "20px !important",
	cursor: "pointer",
	display: "inline-flex",
	alignItems: "center",
	justifyContent: "center",
	height: "34px",
	width: "100%",
};

interface Props {
	selectedValue: RelevancyValue | null;
	onChange: (value: RelevancyValue) => void;
}

const RelevancyToggle: React.FC<Props> = ({ selectedValue, onChange }) => {
	const handleSelect = (value: RelevancyValue) => {
		onChange(value);
	};

	return (
		<ToggleButtonGroup
			sx={{ width: "100%", gap: "10px" }}
			value={selectedValue}
			exclusive
			onChange={(e, v) => {
				handleSelect(v);
			}}
			aria-label="relevance toggle"
		>
			<ToggleButton
				value={RelevancyValue.RELEVANT}
				aria-label="left aligned"
				sx={{
					...sharedButtonStyles,
					"&.Mui-selected": {
						bgcolor: colorGrayLight,
						outline: `1px solid ${colorGrayLight}`,
					},
					"&.Mui-selected:hover": {
						bgcolor: colorGrayLight,
					},
				}}
			>
				<ThumbsUpIcon
					sx={{
						fontSize: 20,
						fill: colorGrayDark,
					}}
				/>
			</ToggleButton>
			<ToggleButton
				value={RelevancyValue.IRRELEVANT}
				aria-label="centered"
				sx={{
					...sharedButtonStyles,
					"&.Mui-selected": {
						bgcolor: colorGrayLight,
						outline: `1px solid ${colorGrayLight}`,
					},
					"&.Mui-selected:hover": {
						bgcolor: colorGrayLight,
					},
				}}
			>
				<ThumbsDownIcon
					sx={{
						fontSize: 20,
						fill: colorGrayDark,
					}}
				/>
			</ToggleButton>
		</ToggleButtonGroup>
	);
};

export default RelevancyToggle;
